<div class="messagesHeader" DraggableDialog>
  <div>Meddelanden</div>
  <div>
    <div>
      <mat-checkbox name="sent" [(ngModel)]="options.sent" ngInit="checked=false">Skickat</mat-checkbox>
      <button style="float:right;margin:-10px -10px 0px 0px" #newMailButton mat-icon-button (click)="newMessage()">
        <mat-icon>add</mat-icon>
      </button>
    </div>
    <div>
      <mat-checkbox name="unread" [(ngModel)]="options.onlyUnread" ngInit="checked=false">Endast olästa</mat-checkbox>
    </div>

  </div>
</div>
<div style="display:block;overflow:scroll;height:100%">
  <mat-accordion displayMode="flat" multi class="mat-table" style="width:100%;">
    <section matSort class="mat-header-row" style="padding-left:4px;padding-right:4px" matSortDisableClear="true">
      <span class="mat-header-cell" disabled="true" mat-sort-header="name">Namn</span>
      <span class="mat-header-cell" mat-sort-header="title">Titel</span>
      <span class="mat-header-cell right-align-text" mat-sort-header="updatedAt">Datum</span>
    </section>
    <div *ngFor="let message of messages">
      <div *ngIf="(!message.isRead && options?.onlyUnread) || !options?.onlyUnread">
        <div *ngIf="(options?.sent && message.recipientID !== null) || message.response; then outBlock else inBlock"></div>
        <ng-template #outBlock>
          <mat-expansion-panel #panel style="background-color:ghostwhite" (opened)="setReadFlag(message)">
            <mat-expansion-panel-header>
              <mat-panel-description [ngClass]="{ 'unread':!message.isRead }">
                <span class="mat-cell">
                  {{message.recipientName}}
                </span>
                <div class="mat-cell" style="flex-direction:row;min-width:0">
                  <div>
                    {{message.title}}
                  </div>
                  <div *ngIf="message.response">
                    >{{message.response}}
                  </div>
                </div>

                <span class="mat-cell" style="text-align:end">
                  {{message.updatedAt|date:"yyyy-MM-dd HH:mm"}}
                </span>
              </mat-panel-description>

            </mat-expansion-panel-header>
            <p>{{message.body}}</p>
          </mat-expansion-panel>
        </ng-template>

        <ng-template #inBlock>

          <mat-expansion-panel #panel style="background-color:white" *ngIf="!message.recipientID" [expanded]="message.id === expandedId" (opened)="setReadFlag(message)" (closed)="closed()">
            <mat-expansion-panel-header>
              <mat-panel-description [ngClass]="{ 'unread':!message.isRead }">
                <span class="mat-cell">
                  {{message.senderName}}
                </span>
                <span class="mat-cell">
                  {{message.title}}
                </span>
                <span class="mat-cell" style="text-align:end">
                  {{message.updatedAt|date:"yyyy-MM-dd HH:mm"}}
                </span>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <p>{{message.body}}</p>



          </mat-expansion-panel>
        </ng-template>



      </div>
    </div>

</mat-accordion>
</div>
